var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex flex-wrap",
      class: [_vm.spacingBetween ? "mw-flex-gap" : ""],
      style: _vm.cssVars,
    },
    _vm._l(_vm.$slots.items, function (item, index) {
      return _c("flex-item", {
        key: index,
        class: _vm.extraClass,
        style: { width: _vm.widthItem },
        attrs: { vnode: item },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }